import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import ForkliftDetailsForm from './forklift-details-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import ForkliftMaintenanceHistory from './forklift-maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditForklift from './edit-forklift';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const ForkliftAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('ForkliftAddEdit -> modalData:', modalData);
  const forkliftData = modalData;
  const [formData, setFormData] = useState(forkliftData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('ForkliftAddEdit -> formData?.id:', formData?.id);
  console.log('ForkliftAddEdit -> formData?.forkliftId:', formData?.forkliftId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(forkliftData?.id || forkliftData?.assetNumber);

  const onChangesForkliftForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Forklift">
              <EditForklift
                data={formData}
                onChanges={onChangesForkliftForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Forklift Maintenance Details">
              <ForkliftDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesForkliftForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <ForkliftMaintenanceHistory
                data={formData}
                forkliftId={formData?.forkliftId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist 
                forkliftId={formData?.forkliftId || formData?.id}
                onCloseModal={handleClose}
                safetyActionRecord={safetyData}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesForkliftForm}
                onCloseModal={handleClose}
                forkliftId={formData?.forkliftId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditForklift
            data={formData}
            onChanges={onChangesForkliftForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="forklift-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Forklift Maintenance Summary' : 'Add Forklift'}
      body={body}
      handleClose={handleClose}
    />
  );
};

ForkliftAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(ForkliftAddEdit);
